import { render } from "./ResponseMain.vue?vue&type=template&id=6d0de812&scoped=true"
import script from "./ResponseMain.vue?vue&type=script&lang=js"
export * from "./ResponseMain.vue?vue&type=script&lang=js"

import "./ResponseMain.vue?vue&type=style&index=0&id=6d0de812&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d0de812"]])

export default __exports__